import { useRef, useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  fontSizeDecrease,
  fontSizeIncrease,
  fontSizeOriginal,
  setLanguageType,
} from "../../../redux/slice/sliceHome";
import Search from "./Search";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import ColorTheme from "./ColorTheme";

const TopHeader = () => {
  const [isSearchOpen, setIsSearchOpen] = useState(false);
  const firstLinkRef = useRef(null);
  const location = useLocation();

  // const printRef = useRef();

  const handlePrint = () => {
    window.print();
  };

  const { languageType } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // Focus the first link on component mount and route change
  useEffect(() => {
    if (firstLinkRef.current) {
      firstLinkRef.current.focus();
    }
  }, [location.pathname]);

  const skipToMain = (e) => {
    e.preventDefault();
    let topPosition;
    let targetElement;

    if (location.pathname === "/") {
      targetElement = document.querySelector("#neepco-main");
      console.log(targetElement);
      if (targetElement) {
        targetElement.focus();
      }

      topPosition = 700;
      window.scrollTo({
        top: topPosition,
        behavior: "smooth",
      });
    }
    // else if (location.pathname === "/power-generation") {
    //   // targetElement = document.querySelector("#neepco-main"); attribute titel select "Hydropower"
    //   const targetElement = document.querySelector('[title="Hydro Power"]');
    //   if (targetElement) {
    //     targetElement.focus();
    //   }
    // }
    else {
      targetElement = document.querySelectorAll(".breadcrumb-item");
      if (targetElement.length > 1) {
        const firstAfterHome = targetElement[1];
        targetElement = firstAfterHome.querySelector('a, [role="link"]');
        targetElement.focus();
      }
      topPosition = 100;
      window.scrollTo({
        top: topPosition,
        behavior: "smooth",
      });
    }
  };

  function handleClick(event) {
    event.preventDefault();
    navigate("/screen-reader");
  }

  const handleLanguageChange = (e) => {
    const selectedLanguage = e.target.value;

    dispatch(setLanguageType(selectedLanguage));
    // sessionStorage.setItem(
    localStorage.setItem(
      "languageType",
      selectedLanguage === "" ? "en" : selectedLanguage,
    ); // Store language in local storage
  };

  return (
    <>
      {/* <div className="top-header" ref={printRef}> */}
      <div className="top-header">
        <div className="row">
          <div className="col-12 col-sm-12 col-md-12 col-lg-12 top-right-nav">
            <ul>
              <li>
                <a href="http://localhost:3000/northeasternelectricpower/reservoir-status">
                  ext log
                </a>
                <a
                  ref={firstLinkRef}
                  // title={getText("Go to Main Content", "मुख्य विषय वस्तु में जाएं")}
                  href={"#"}
                  onClick={skipToMain}
                  onKeyDown={(e) => {
                    // Trigger on Enter (keyCode 13) or Space (keyCode 32)
                    if (e.key === "Enter" || e.key === " ") {
                      // e.preventDefault(); // Prevent default behavior (scrolling to #)
                      skipToMain(e);
                    }
                  }}
                  className="hide skiptomain"
                  role="link"
                >
                  {getText("Go to Main Content", "मुख्य विषय वस्तु में जाएं")}
                </a>
              </li>
              <li>
                <Link
                  to={"important-links"}
                  className="hide skiptomain"
                  title={getText("Important Links", "महत्वपूर्ण लिंक")}
                >
                  {getText("Important Links", "महत्वपूर्ण लिंक")}
                </Link>
              </li>
              <li>
                <Link
                  to={"sitemap"}
                  className="hide skiptomain"
                  // onClick={(e) => e.preventDefault()}
                  title={getText("Site Map", "साइट मानचित्र")}
                >
                  {getText("Site Map", "साइट मानचित्र")}
                </Link>
              </li>
              <li>
                <a
                  href={"#"}
                  // onClick={(e) => e.preventDefault()}
                  onClick={handlePrint}
                  className="hide skiptomain"
                  title={getText("Print", "प्रिंट")}
                >
                  {getText("Print", "प्रिंट")}
                </a>
              </li>
              <li>
                <a
                  className="hide"
                  href="#"
                  onClick={handleClick}
                  title={getText("Screen Reader", "स्क्रीन रीडर")}
                >
                  {getText("Screen Reader", "स्क्रीन रीडर")}
                </a>
              </li>
              <li className="text-size">
                <a
                  href={"#"}
                  title={getText("A-", "अ-")}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(fontSizeDecrease());
                  }}
                >
                  {getText("A-", "अ-")}
                </a>
                <a
                  href={"#"}
                  title={getText("A", "अ")}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(fontSizeOriginal());
                  }}
                >
                  {getText("A", "अ")}
                </a>
                <a
                  href={"#"}
                  title={getText("A+", "अ+")}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(fontSizeIncrease());
                  }}
                >
                  {getText("A+", "अ+")}
                </a>
              </li>

              <ColorTheme />
              <li className="lang-select">
                <label htmlFor="language-select" className="visually-hidden">
                  {getText("Language", "भाषा")}
                </label>
                <select
                  id="language-select"
                  className="form-select custom-lang-select"
                  onChange={handleLanguageChange}
                  value={languageType}
                  aria-label={getText("Language", "भाषा")}
                >
                  <option value="">English</option>
                  <option value="hi">हिंदी</option>
                </select>
              </li>

              <li className="login-btn">
                <button
                  type="button"
                  title={getText("Toggle Search", "खोज चालू/बंद करें")}
                  aria-label={getText("Toggle Search", "खोज चालू/बंद करें")}
                  onClick={(e) => {
                    e.preventDefault();
                    setIsSearchOpen(!isSearchOpen);
                  }}
                >
                  {/* {!isSearchOpen ? (
                    <i className="fa fa-search" aria-hidden="true"></i>
                  ) : (
                    <i className="fa fa-times" aria-hidden="true"></i>
                  )} */}
                  {!isSearchOpen ? (
                    <>
                      <span className="visually-hidden">
                        {getText("Search", "खोज")}
                      </span>
                      <i className="fa fa-search" aria-hidden="true"></i>
                    </>
                  ) : (
                    <>
                      <span className="visually-hidden">
                        {getText("Close search", "खोज बंद करें")}
                      </span>
                      <i className="fa fa-times" aria-hidden="true"></i>
                    </>
                  )}
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
      {isSearchOpen && <Search setIsSearchOpen={setIsSearchOpen} />}
    </>
  );
};

export default TopHeader;
